module.exports = __webpack_public_path__ + "static/media/tenceData.25784248.xls";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/excelTeml/tenceData.xls
// module id = 5159
// module chunks = 0